var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hi-Fi",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Orders",
    transform: "translate(-374.000000, -106.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(152.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table/!table-white",
    transform: "translate(0.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(222.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8596492,15.0206628 L11.8362574,10.997271 C11.7645225,10.9255361 11.6709552,10.8881092 11.5711501,10.8881092 L11.2499026,10.8881092 C12.3196882,9.73099419 12.9746589,8.18713454 12.9746589,6.48732946 C12.9746589,2.90370372 10.0709552,0 6.48732946,0 C2.90370372,0 0,2.90370372 0,6.48732946 C0,10.0709552 2.90370372,12.9746589 6.48732946,12.9746589 C8.18713454,12.9746589 9.73099419,12.3196882 10.8881092,11.2530215 L10.8881092,11.5711501 C10.8881092,11.6709552 10.928655,11.7645225 10.997271,11.8362574 L15.0206628,15.8596492 C15.1672515,16.0062379 15.4042886,16.0062379 15.5508773,15.8596492 L15.8596492,15.5508773 C16.0062379,15.4042886 16.0062379,15.1672515 15.8596492,15.0206628 Z M6.48732946,11.9766082 C3.45263159,11.9766082 0.998050686,9.52202733 0.998050686,6.48732946 C0.998050686,3.45263159 3.45263159,0.998050686 6.48732946,0.998050686 C9.52202733,0.998050686 11.9766082,3.45263159 11.9766082,6.48732946 C11.9766082,9.52202733 9.52202733,11.9766082 6.48732946,11.9766082 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.96124cbc4eba4ac9f0d80db0bb4d235a.svg";
export { ForwardRef as ReactComponent };